/// <reference path="global.d.ts" />
// @ts-ignore
let $ = window.jQuery;

interface DialogOptions {
    showCloseButton?: boolean;
    closeButtonText?: string;
    next?: () => void;
    nextText?: string;
    nextClasses?: string;
    footer?: JQuery;
}

export function createDialog(title: string, content: string, opts: DialogOptions = {}): DialogElement {
    opts = $.extend({
        showCloseButton: false,
        closeButtonText: 'Close',
        next: null,
        nextText: 'Continue',
        nextClasses: '',
        footer: null,
    }, opts) as DialogOptions;

    // create new dialog element with jQuery
    const dialog = $.extend($('<dialog class="gf-pdf-modal"><div class="gf-pdf-modal-header"><div class="gf-pdf-modal-title"></div></div><div class="gf-pdf-modal-content"></div><div class="gf-pdf-modal-footer"></div></dialog>'), {
        showDialog: function(): DialogElement {
            this[0].showModal();
            return this;
        },
        showCloseButton: function (v: boolean): DialogElement {
            if (v) {
                this.find('.gf-pdf-modal-header').append(`<span class="gf-pdf-button -small -cancel gf-pdf-modal-close">${opts.closeButtonText}</span>`);
            } else {
                this.find('.gf-pdf-modal-close').remove();
            }
            return this;
        },
        setContent: function (c: string): DialogElement {
            this.find('.gf-pdf-modal-content').html(c);
            return this;
        },
        setFooter: function (c: string): DialogElement {
            this.find('.gf-pdf-modal-footer').html(c);
            return this;
        },
        setTitle: function (c: string): DialogElement {
            this.find('.gf-pdf-modal-header .gf-pdf-modal-title').html(c);
            return this;
        }

    }) as DialogElement;

    $('body').append(dialog);
    dialog.setTitle(title);

    if (opts.showCloseButton) {
        dialog.showCloseButton(true);
    }

    dialog.setContent(content);

    if (opts.next && !opts.footer) {
        dialog.setFooter(`<button class="gf-pdf-button continue-layout-selected ${opts.nextClasses}" type="submit">${opts.nextText}</button>`);
    }

    if (opts.footer) {
        dialog.find('.gf-pdf-modal-content').append(opts.footer);
    }

    dialog.on('click', '.continue-layout-selected', function (e) {
        e.preventDefault();
        opts.next();
        dialog.remove();
    });

    dialog.on('click', '.gf-pdf-modal-close', function (e) {
        dialog.remove();
    });

    // The dialog element will autofocus on the first focusable element inside of it.
    // We prevent this by focusing on the dialog itself, then blurring it.
    const showModal = dialog[0].showModal;
    dialog[0].showModal = function () {
        showModal.call(dialog[0]);
        dialog.trigger('focus').trigger('blur');
    };
    return dialog;
}

export function createLoadingDialog(title: string): DialogElement {
    const dialog = createDialog(title, `<div class="gf-pdf-modal-centered"><div class="gf-pdf-spinner"></div></div>`);
    dialog.showDialog();
    return dialog;
}